var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolderBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72424 0.499565C9.72424 0.223423 9.50038 -0.000434875 9.22424 -0.000434875C8.94809 -0.000434875 8.72424 0.223423 8.72424 0.499565V1.2248H7.94831C7.67217 1.2248 7.44831 1.44866 7.44831 1.7248C7.44831 2.00094 7.67217 2.2248 7.94831 2.2248H8.72424V2.95003C8.72424 3.05331 8.75555 3.14928 8.8092 3.22895H3.90215V2.11874H-0.00012207V4.33916H10.4059V3.22895H9.63927C9.69292 3.14928 9.72424 3.05331 9.72424 2.95003V2.2248H10.5002C10.7763 2.2248 11.0002 2.00094 11.0002 1.7248C11.0002 1.44866 10.7763 1.2248 10.5002 1.2248H9.72424V0.499565ZM-0.00012207 10.4453V5.44938H10.4059V10.4453C10.4059 10.7562 10.1198 11.0004 9.75555 11.0004H0.650256C0.286044 11.0004 -0.00012207 10.7562 -0.00012207 10.4453Z",
    fill: "#7D94AE",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolderBlue);
export default __webpack_public_path__ + "static/media/add-folder-blue.8234fb445c54349016041d5cfedbdaad.svg";
export { ForwardRef as ReactComponent };